module.exports = __webpack_public_path__ + "c0efa8e63418695b196467df190bbe87.MP3";